import React, { useEffect, useState } from 'react';
import axios from 'axios';
import withRoleAccess from '../../hoc/withRoleAccess';
import { useTranslation } from 'react-i18next';
import {
  Layout,
  Tabs,
  Row,
  Col,
  Spin,
  Alert,
} from 'antd';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import SubjectCard from './SubjectCard';
import SubjectDetailsModal from './SubjectDetailsModal';

const { Content } = Layout;

function Subject() {
  const { t } = useTranslation();
  const [subjects, setSubjects] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  const handleViewDetailsClick = (subject) => {
    setSelectedSubject(subject);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedSubject(null);
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(`${API_URL}/subjects`);
        const groupedSubjects = groupBySubjectGroup(response.data);
        setSubjects(groupedSubjects);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching subjects:', error);
        setError(t('errorFetchingSubjects'));
        setLoading(false);
      }
    };

    fetchSubjects();
  }, [API_URL, t]);

  const groupBySubjectGroup = (subjectsArray) => {
    return subjectsArray.reduce((grouped, subject) => {
      const group = subject.subjectgroup;
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(subject);
      return grouped;
    }, {});
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <Alert message={error} type="error" showIcon />
      </div>
    );
  }

  const items = Object.entries(subjects).map(([group, groupSubjects]) => ({
    key: group,
    label: group,
    children: (
      <Row gutter={[24, 24]} style={{ padding: '24px 0' }}>
        {groupSubjects.map(subject => (
          <Col xs={24} sm={12} md={8} lg={6} key={subject.subjectid}>
            <SubjectCard
              subject={subject}
              onDetailsClick={handleViewDetailsClick}
            />
          </Col>
        ))}
      </Row>
    ),
  }));

  return (
    <Layout>
      <Sidebar />
      <Layout>
        <Header />
        <Content style={{ marginTop: '50px', marginBottom: '70px', padding: '24px', minHeight: '280px', background: '#f5f5f5' }}>
          <div style={{ maxWidth: 1290, margin: '0 auto' }}>
            <Tabs
              items={items}
              type="card"
              size="large"
              style={{
                background: 'white',
                padding: '24px',
                borderRadius: '8px',
                boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
              }}
            />

            <SubjectDetailsModal
              open={showModal}
              subject={selectedSubject}
              onClose={handleCloseModal}
            />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default withRoleAccess(Subject, ['admin', 'superadmin', 'teacher', 'student']);
